export default (path = '') => `${window.theStart?.static ?? '/static'}/${path}`
